<p-toast></p-toast>
<div *ngIf="showTable" class="selectionDropdown-container">
    <div class="card dropdown-content" style="margin-bottom: 5px;">
        <!-- <h4>Estimation Detail</h4> -->
        <div class="p-fluid p-formgrid grid justify-content-center">

            <div class="field col-12 md:col-4">
                <label htmlFor="applicationType">{{'APPLICATION_TYPE'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="applicationTypeDD" [(ngModel)]="selectedApplicationType" (onChange)="onSelectApplicationType()"
                        placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="appType"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label htmlFor="UserType">{{'USER_TYPE'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="userTypeDD" [(ngModel)]="selectedUserType" (onChange)="onSelectUserType()"
                        placeholder="{{'SELECT_USER_TYPE'| translate}}" optionLabel="userType"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label htmlFor="programmeName">{{'PROGRAMME_NAME'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="programNameDD" [(ngModel)]="selectedProgramName" (onChange)="onSelectprogramName()"
                        placeholder="{{'SELECT_PROGRAMME_NAME'| translate}}" optionLabel="programType"></p-dropdown>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mi-survey-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-table #miSurvey [value]="miSurveyData" [(selection)]="filteredDataForExport" dataKey="AppId_ProgID"
                (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
                [paginator]="true" [globalFilterFields]="[
                'Scheme_Specific_Id',
                'Farmer_Name_In_English',
                'Full_Name_in_Recognized_Official_Language', 
                'Gender',
                'Address_Line_1',
                'Address_Line_2',
                'Address_Line_3',
                'District',
                'State', 
                'Country', 
                'Farmer_Bank_Name', 
                'Farmer_IFSCCode',
                'Farmer_Account_Number', 
                'Aadhar_Number', 
                'Pincode', 
                'Center_Share_Payment_Amount', 
                'State_Share_Payment_Amount',
                'FinYear',
                'ApplicantType',
                'UserType',
                'MIArea',
                'Programme_Name',
                'Caste_Description',
                'TopUp',
                'Village',
                'Block',
                'Total_Area',
                'Crop_Name',
                'FarmerType'
                ]" responsiveLayout="scroll" [rowHover]="true" currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true" [rowsPerPageOptions]="[10,25,50,100,500,1000,1500,3000,5000]" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MII_SUBSIDY_TO_FARMER_LOT'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                        <th pSortableColumn="Farmer_Name_In_English">{{'FULL_NAME_IN_ENGLISH'| translate}}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Full_Name_in_Recognized_Official_Language">{{'FULL_NAME_RECOGNIZED'| translate}}
                            <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language" display="menu"></p-columnFilter>
                            <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                            <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Gender">{{'GENDER'| translate}}
                            <p-columnFilter type="text" field="Gender" display="menu"></p-columnFilter>
                            <p-sortIcon field="Gender"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_1">{{'ADDRESS_LINE_1'| translate}}
                            <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_2">{{'ADDRESS_LINE_2'| translate}}
                            <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_3">{{'ADDRESS_LINE_3'| translate}}
                            <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'Village' | translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State">{{'STATE'| translate}}
                            <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                            <p-sortIcon field="State"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Country">{{'COUNTRY'| translate}}
                            <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                            <p-sortIcon field="Country"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerType">{{'FARMER_TYPE' | translate}}
                            <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Bank_Name">{{'FARMER_BANK_NAME'| translate}}
                            <p-columnFilter type="text" field="Farmer_Bank_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Bank_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_IFSCCode">{{'FARMER_IFSC_CODE'| translate}}
                            <p-columnFilter type="text" field="Farmer_IFSCCode" display="menu"></p-columnFilter>
                            <p-sortIcon field="PrograFarmer_IFSCCodemmeName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Account_Number">{{'FAMER_ACCOUNT_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Farmer_Account_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Account_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pincode">{{'PINCODE'| translate}}
                            <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pincode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID'| translate}}
                            <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp">{{'TOP_UP'| translate}}
                            <p-columnFilter type="text" field="TopUp" display="menu"></p-columnFilter>
                            <p-sortIcon field="TopUp"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ApplicantType">{{'APPLICATION_TYPE'| translate}}
                            <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ApplicantType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Programme_Name">{{'PROGRAM_NAME'| translate}}
                            <p-columnFilter type="text" field="Programme_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Programme_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                            <p-columnFilter type="text" field="Crop_Name" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Crop_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserType">{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="UserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MIArea">{{'MIAREA'| translate}}
                            <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Area">{{'TOTAL_LAND_HOLDING' | translate}}
                            <p-columnFilter type="Total_Area" field="Total_Area" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectFarmerApplication(product)"></button>
                        </td>
                        <td>{{product?.Farmer_Name_In_English}}</td>
                        <td>{{product?.Full_Name_in_Recognized_Official_Language}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product?.Gender}}</td>
                        <td>{{product?.Address_Line_1}}</td>
                        <td>{{product?.Address_Line_2}}</td>
                        <td>{{product?.Address_Line_3}}</td>
                        <td>{{product?.Village}}</td>
                        <td>{{product?.Block}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.State}}</td>
                        <td>{{product?.Country}}</td>
                        <td>{{product?.FarmerType}}</td>
                        <td>{{product?.Farmer_Bank_Name}}</td>
                        <td>{{product?.Farmer_IFSCCode}}</td>
                        <td>{{product?.Farmer_Account_Number}}</td>
                        <td>{{product?.Aadhar_Number}}</td>
                        <td>{{product?.Pincode}}</td>
                        <td>{{product?.Scheme_Specific_Id}}</td>
                        <td>{{product?.Center_Share_Payment_Amount}}</td>
                        <td>{{product?.State_Share_Payment_Amount}}</td>
                        <td>{{product?.TopUp}}</td>
                        <td>{{product?.ApplicantType}}</td>
                        <td>{{product?.Programme_Name}}</td>
                        <td>{{product?.Crop_Name}}</td>
                        <td>{{product?.UserType}}</td>
                        <td>{{product?.MIArea}}</td>
                        <td>{{product?.Total_Area}}</td>
                        <td>{{product?.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'MI_SUBSIDY_TO_FARMER_LOT'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="filteredData.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATION_FILTERED_FOR_MI_SUBSIDY'| translate}}: {{ totalSelectedApp }}</b></h5>

            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="Download Filtered Lot Data"
                    icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>

            <div class="card">
                <p-toolbar *ngIf="filteredData.length">
                    <ng-template pTemplate="left">

                    </ng-template>
                    <ng-template pTemplate="right">
                        <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3">
                        </p-dropdown>
                        <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                            rows="3" cols="20" class="mr-3"></textarea>
                        <button pButton pRipple label=" {{'SUBMIT'| translate}}" (click)="handleClick()" class="p-button-help"></button>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>

    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>